module.exports = __webpack_public_path__ + "media/images/front/services/production-9ac5db6ba6895bd30de4ed7df4ef38f0.webp";